<section id="schedaPartner" class="content-padding darker">
  <div class="narrow-wrapper">
    <form class="has-cols" [formGroup]="_partnerForm" (ngSubmit)="onSubmit()" *ngIf="_partnerForm">

      <div class="expert-personal-info">
        <fieldset>
          <legend>PERSONAL INFORMATION:</legend>
          <div class="col-48 grid-element">
            <!-- <label for="ragioneSociale">Ragione Sociale{{ _partnerForm.get("businessName") | required }}</label> -->
            <label for="ragioneSociale">NOME{{ _partnerForm.get("businessName") | required }}</label>
            <input type="text" name="businessName" formControlName="businessName">
            <app-error-html-handler [ctrl]="_partnerForm.get('businessName')" [messages]="formValidationMsgs.businessName"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" formGroupName="user">
            <label for="email">E-mail{{ _partnerForm.get('user').get('email') | required }}</label>
            <input type="email" name="email" formControlName="email">
            <app-error-html-handler [ctrl]="_partnerForm.get('user').get('email')" [messages]="formValidationMsgs.user.email"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element">
            <label for="partitaIVA">Partita IVA{{ _partnerForm.get("vatCode") | required }}</label>
            <input type="text" name="vatCode" formControlName="vatCode" (blur)="onVatBlur()">
            <app-error-html-handler [ctrl]="_partnerForm.get('vatCode')" [messages]="formValidationMsgs.vatCode"></app-error-html-handler>
            <div *ngIf="vatStatus === 'checking'">
              Verifica in corso...
            </div>
          </div>

          <div class="col-48 grid-element">
            <label for="cf">Codice Fiscale{{ _partnerForm.get("fiscalCode") | required }}</label>
            <input type="text" name="fiscalCode" formControlName="fiscalCode" maxlength="16">
            <app-error-html-handler [ctrl]="_partnerForm.get('fiscalCode')" [messages]="formValidationMsgs.fiscalCode"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element">
            <label for="indirizzo">
              Indirizzo{{ _partnerForm.get("address") | required }}
              <span class="directions" (click)="directions($event)"><i class="fas fa-directions"></i></span>
            </label>
            <app-google-maps-search (setAddress)="getAddress($event)" addressType="geocode" [control]="_partnerForm.get('address')"></app-google-maps-search>
            <app-error-html-handler [ctrl]="_partnerForm.get('address')" [messages]="formValidationMsgs.address"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element">
            <label for="telefono">Telefono{{ _partnerForm.get("phone") | required }}</label>
            <input type="text" name="phone" formControlName="phone">
            <app-error-html-handler [ctrl]="_partnerForm.get('phone')" [messages]="formValidationMsgs.phone"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" formGroupName="user">
            <label for="cognomeReferente">Cognome referente{{ _partnerForm.get('user').get('surname') | required }}</label>
            <input type="text" name="surname" formControlName="surname">
            <app-error-html-handler [ctrl]="_partnerForm.get('user').get('surname')" [messages]="formValidationMsgs.user.surname"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" formGroupName="user">
            <label for="nomeReferente">Nome referente{{ _partnerForm.get('user').get('name') | required }}</label>
            <input type="text" name="name" formControlName="name">
            <app-error-html-handler [ctrl]="_partnerForm.get('user').get('name')" [messages]="formValidationMsgs.user.name"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element">
            <label for="ragioneSociale">AZIENDA{{ _partnerForm.get("agency") | required }}</label>
            <input type="text" name="agency" formControlName="agency">
            <app-error-html-handler [ctrl]="_partnerForm.get('agency')" [messages]="formValidationMsgs.agency"></app-error-html-handler>
          </div>

        </fieldset>
        <br class="clear"> 
      </div>

      <div class="expert-personal-info" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader'))">
        <fieldset>
          <legend>PARTNER PROVINCIA:</legend>
          <div class="grid-element-full" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader'))">
            <label style="position: relative; top: 20px;">Provincia{{ _partnerForm.get('partnerProvinces')?.controls[0]?.controls?.province?.id | required }}*</label>
            <div formArrayName="partnerProvinces">
              <div class="offer-products"
                *ngFor="let provinceForm of _partnerForm.get('partnerProvinces').controls; let i = index">
                <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                  <label for=""></label>
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProvince(i)"></i>
                  </div>
                  <div class="product-q" formGroupName="province">
                    <div class="porduct-qty">
                      <div class="province-input">
                        <label for=""></label>
                         <ng-select formControlName="id">
                          <ng-option *ngFor="let province of provinces" [value]="province.id" [disabled]="isProvinceOptionDisabled(province)">
                            <b>{{ province?.provinceCode }}</b> {{ province?.province }}
                          </ng-option>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <br>
                  <app-error-html-handler [ctrl]="provinceForm?.controls?.province?.controls?.id"
                    [messages]="formValidationMsgs?.partnerProvinces?.province?.id">
                  </app-error-html-handler>
                </div>
              </div>
            </div>
            <div class="center" style="width: 100%;">
              <button class="btn mt-0" (click)="$event.preventDefault(); addProvince()">
                Aggiungi Provincia<i class="ml-10 fas fa-plus"></i>
              </button>
            </div>
          </div>
        </fieldset>
        <br class="clear">
      </div>

      <div class="expert-personal-info" *ngIf="groups.includes('admin')">
        <fieldset>
          <legend>SERVIZIO:</legend>
          <div class="grid-element-full" *ngIf="groups.includes('admin')">
            <!-- <label style="position: relative; top: 20px;">Servizio{{ _partnerForm.get('partnerServices')?.controls[0]?.controls?.service?.id | required }}*</label> -->
            <div formArrayName="partnerServices">
              <div class="offer-products"
                *ngFor="let serviceForm of _partnerForm.get('partnerServices').controls; let i = index">
                <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                  <label for=""></label>
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-service"  (click)="removeService(i)"></i>
                  </div>
                  <div class="product-q" formGroupName="service">
                    <fieldset style="padding-top: 0px; margin-top: 15px;">
                      <legend></legend>
                      <div class="porduct-qty">
                        <div [ngClass]="showPricePerItem[i] ? 'saifu-input-100-width' : 'saifu-input'">
                          <label for="">Servizio</label>
                           <ng-select bindLabel="serviceName" bindValue="id" formControlName="id" (change)="handleServiceChange($event, i)">
                            <ng-option *ngFor="let service of services" [value]="service.id" [ngClass]="(service?.pricingModel?.toLowerCase() === 'fixedprice' || service?.pricingModel?.toLowerCase() === 'corporate' ? 'grid-element-full' : '')" [disabled]="isOptionDisabled(service)">
                              {{ service.serviceName }}
                            </ng-option>
                          </ng-select>
                        </div>
                        
                        <div [ngClass]="showPricePerItem[i] ? 'three-items' : (showExtraKmInput[i] ? 'saifu-input-inner' : 'saifu-input')">
                            <label for="" *ngIf="!showSalesTypeLabel[i] && !showCorporateServiceLabel[i]">Servizio Prezzo</label>
                            <label for="" *ngIf="showSalesTypeLabel[i]">PERCENTUALE SU PREZZO *100</label>
                            <label for="" *ngIf="showCorporateServiceLabel[i]">Costo Consegna</label>
                            <input type="text" formControlName="price" placeholder="Servizio Prezzo">
                            <app-error-html-handler
                              [ctrl]="serviceForm?.controls?.service?.controls?.price"
                              [messages]="formValidationMsgs?.partnerServices?.service?.price">
                            </app-error-html-handler>
                        </div>

                        <div class="" [ngClass]="showPricePerItem[i] ? 'three-items' : 'saifu-input'" *ngIf="showPricePerItem[i]">
                          <label for="">PRICE PER PRODUCT</label>
                          <input type="text" formControlName="pricePerItem" placeholder="Price per product">
                          <app-error-html-handler
                            [ctrl]="serviceForm?.controls?.service?.controls?.pricePerItem"
                            [messages]="formValidationMsgs?.partnerServices?.service?.pricePerItem">
                          </app-error-html-handler>
                        </div>

                        <div [ngClass]="showPricePerItem[i] ? 'three-items' : (showExtraKmInput[i] ? 'saifu-input-inner' : 'saifu-input')" *ngIf="showExtraKmInput[i]">
                          <label for="">Extra KM PREZZO</label>
                          <input type="text" formControlName="extraKmPrice" placeholder="Extra KM Prezzo">
                          <app-error-html-handler
                            [ctrl]="serviceForm?.controls?.service?.controls?.extraKmPrice"
                            [messages]="formValidationMsgs?.partnerServices?.service?.extraKmPrice">
                          </app-error-html-handler>
                        </div>
                        <!--
                        <div class="saifu-input" *ngIf="showExtraKmInput[i]">
                          <label for="">EXTRA FUORICITTÀ PREZZO</label>
                          <input type="text" formControlName="extraOutSideCityKmPrice" placeholder="">
                          <app-error-html-handler
                            [ctrl]="serviceForm?.controls?.service?.controls?.extraOutSideCityKmPrice"
                            [messages]="formValidationMsgs?.partnerServices?.service?.extraOutSideCityKmPrice">
                          </app-error-html-handler>
                        </div>
                        -->
                      </div>
                    </fieldset>
                  </div>
                  <br>
                  <app-error-html-handler [ctrl]="serviceForm?.controls?.service?.controls?.id"
                    [messages]="formValidationMsgs?.partnerServices?.service?.id">
                  </app-error-html-handler>
                </div>
              </div>
            </div>
            <div class="center" style="width: 100%;">
              <button class="btn mt-0" (click)="$event.preventDefault(); addService()">
                Aggiungi Servizio<i class="ml-10 fas fa-plus"></i>
              </button>
            </div>
          </div>

          <div class="col-48 grid-element" *ngIf="groups.includes('admin')">
            <label for="kmIncluded">KM Included</label>
            <input type="text" name="name" formControlName="kmIncluded">
            <app-error-html-handler [ctrl]="_partnerForm.get('kmIncluded')" [messages]="formValidationMsgs.kmIncluded">
            </app-error-html-handler>
          </div>

          <div class="col-48 grid-element">
            <label for="">EXTRA FUORICITTÀ PREZZO</label>
            <input type="text" formControlName="extraOutSideCityKmPrice" placeholder="">
            <app-error-html-handler [ctrl]="_partnerForm.get('extraOutSideCityKmPrice')" [messages]="formValidationMsgs?.extraOutSideCityKmPrice"></app-error-html-handler>
          </div>

        </fieldset>
        
        <br class="clear">
      </div>

      <div class="expert-personal-info" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader'))">
        <fieldset>
          <legend>Categorie di prodotti:</legend>
          <div class="grid-element-full" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader'))">
            <label style="position: relative; top: 20px;">Categorie di prodotti venduti dal partner{{ _partnerForm.get("partnerSoldProductCategories") | required }}</label>
            <div>
              <div class="offer-products">
                <div class="" style="display: table; width: 100%;">
                  <label for=""></label>
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-product"></i>
                  </div>
                  <div class="product-q">
                    <div class="porduct-qty">
                      <div class="province-input">
                        <label for=""></label>
                         <ng-select formControlName="partnerSoldProductCategories" multiple="true" hideSelected="true" markFirst="true">
                            <ng-option *ngFor="let productCategory of productCategories" [value]="productCategory.id">
                              {{ productCategory?.categoryName }}
                            </ng-option>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <br>
                  <app-error-html-handler [ctrl]="_partnerForm.get('partnerSoldProductCategories')" [messages]="formValidationMsgs.partnerSoldProductCategories">
                  </app-error-html-handler>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <br class="clear">
      </div>

      <div class="expert-personal-info" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
        <fieldset>
          <legend>NOTIFICHE:</legend>

          <div class="col-48 grid-element">
            <label class="toggle-container" for="sendSms">
              <input type="checkbox" id="sendSms" formControlName="sendSms">
              <span class="toggle-switch"></span>
              POSSIBILITÀ DI INVIARE SMS
            </label>
          </div>
    
          <div class="col-48 grid-element" *ngIf="(groups.includes('admin'))">
            <label class="toggle-container" for="receiveWhatsappMsg">
              <input type="checkbox" id="receiveWhatsappMsg" formControlName="receiveWhatsappMsg">
              <span class="toggle-switch"></span>
              NOTIFICHE WHATSAPP
            </label>
          </div>
    
          <div class="col-48 grid-element" *ngIf="(groups.includes('admin'))">
            <label class="toggle-container" for="receiveEmailMsg">
              <input type="checkbox" id="receiveEmailMsg" formControlName="receiveEmailMsg">
              <span class="toggle-switch"></span>
              NOTIFICHE MAIL
            </label>
          </div>

          <div class="col-48 grid-element" *ngIf="(groups.includes('admin'))">
            <label class="toggle-container" for="activityReminder">
              <input type="checkbox" id="activityReminder" formControlName="activityReminder">
              <span class="toggle-switch"></span>
              Promemoria attività
            </label>
          </div>
          
        </fieldset>
        <br class="clear">
      </div>

      <div class="expert-personal-info">
        <fieldset *ngIf="((groups.includes('admin')) || (groups.includes('operation')) || (groups.includes('partner') && _partnerForm.get('partnerPaymentMethod').value === 'creditCard'))">
          <legend>Pagamenti e contratto:</legend>

          <div class="col-48 grid-element">
            <mat-form-field appearance="outline" class="date-picker-field">
              <mat-label>Periodo di validità del contratto</mat-label>
              <mat-date-range-input formGroupName="contractValidity" [rangePicker]="picker">
                <input matStartDate formControlName="startContractDate" placeholder="Data di inizio">
                <input matEndDate formControlName="endContractDate" placeholder="Data di fine">
              </mat-date-range-input>
              <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <app-error-html-handler
              [ctrl]="_partnerForm.get('contractValidity')"
              [messages]="formValidationMsgs.contractValidity">
            </app-error-html-handler>

            <!--
            <p *ngIf="_partnerForm.get('contractValidity')?.value?.startContractDate && _partnerForm.get('contractValidity')?.value?.endContractDate">
              {{ _partnerForm.get('contractValidity')?.value?.startContractDate | date:'fullDate' | titlecase }}
              –
              {{ _partnerForm.get('contractValidity')?.value?.endContractDate | date:'fullDate' | titlecase }}
            </p>
            -->
          </div>
          <br class="clear">

          <div class="col-48 grid-element" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
            <label for="name">metodo di pagamento</label>
            <select name="" id="" formControlName="partnerPaymentMethod">
              <option disabled selected="true"></option>
              <option value="bankTransfer">Bank Transfer</option>
              <option value="creditCard">Credit Card</option>
              <option value="directDebitMandate">Direct Debit Mandate</option>
            </select>
            <app-error-html-handler [ctrl]="_partnerForm.get('partnerPaymentMethod')" [messages]="formValidationMsgs.partnerPaymentMethod"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label for="bankAccount">Conto bancario{{ _partnerForm.get('bankAccount') | required }}</label>
            <input type="text" name="bankAccount" formControlName="bankAccount">
            <app-error-html-handler [ctrl]="_partnerForm.get('bankAccount')" [messages]="formValidationMsgs.bankAccount"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label for="bankAccountName">Nome del conto bancario{{ _partnerForm.get('bankAccountName') | required }}</label>
            <input type="text" name="bankAccountName" formControlName="bankAccountName">
            <app-error-html-handler [ctrl]="_partnerForm.get('bankAccountName')" [messages]="formValidationMsgs.bankAccountName"></app-error-html-handler>
          </div>
          
          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label for="sdiCode">CODICE SDI{{ _partnerForm.get('sdiCode') | required }}</label>
            <input type="text" name="sdiCode" formControlName="sdiCode">
            <app-error-html-handler [ctrl]="_partnerForm.get('sdiCode')" [messages]="formValidationMsgs.sdiCode"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label for="certifiedEmail">Certified Email{{ _partnerForm.get('certifiedEmail') | required }}</label>
            <input type="text" name="certifiedEmail" formControlName="certifiedEmail">
            <app-error-html-handler [ctrl]="_partnerForm.get('certifiedEmail')" [messages]="formValidationMsgs.certifiedEmail"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label for="name">stato del pagamento</label>
            <select name="" id="" formControlName="partnerPaymentStatus">
              <option disabled selected="true"></option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="blocked">Blocked</option>
            </select>
            <app-error-html-handler [ctrl]="_partnerForm.get('partnerPaymentStatus')" [messages]="formValidationMsgs.partnerPaymentStatus"></app-error-html-handler>
          </div>
          
        </fieldset>
        <br class="clear">
      </div>

      <div class="expert-personal-info" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
        <fieldset>
          <legend>FATTURAZIONE & ACTIONS:</legend>
          <div class="col-48 grid-element">
            <label for="">MAIL FATTURAZIONE</label>
              <input type="text" formControlName="billingEmail" placeholder="">
              <app-error-html-handler [ctrl]="_partnerForm.get('billingEmail')" [messages]="formValidationMsgs?.billingEmail"></app-error-html-handler>
          </div>
          
          <div class="grid-element-full">
            <label class="toggle-container" for="billingAccess">
              <input type="checkbox" id="billingAccess" formControlName="billingAccess">
              <span class="toggle-switch"></span>
              ABILITA FATTURAZIONE
            </label>
          </div>
        </fieldset>
        <br class="clear">
      </div>

      <div class="expert-personal-info">
        <fieldset>
          <legend>INDIRIZZO DI RITIRO MULTIPLO:</legend>

          <div class="col-48 grid-element">
            <label class="toggle-container" for="multiplePickUpAddress">
              <input type="checkbox" id="multiplePickUpAddress" formControlName="isMultiplePickUpAddress">
              <span class="toggle-switch"></span>
              È UN INDIRIZZO DI RITIRO MULTIPLO
            </label>
          </div>

          <div class="grid-element-full">
            <div formArrayName="pickupAddresses" *ngIf="_partnerForm.get('isMultiplePickUpAddress')?.value">
              <div class="offer-products" *ngFor="let address of pickupAddresses.controls; let i = index">
                <div class="" style="display: table; width: 100%;">
                  <label for=""></label>
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-multi-address"  (click)="removePickupAddress(i)"></i>
                  </div>
                  <div class="grid-element-full">
                    <label>
                      Indirizzo di Ritiro {{ i+1 }}
                      <span class="directions" > <i class="fas fa-directions fa-2x"></i></span>
                    </label>
                    <app-google-maps-search
                      (setAddress)="getPickupAddress($event, i)"
                      addressType="geocode"
                      [control]="pickupAddresses.at(i)">
                    </app-google-maps-search>
                
                    <!-- Validation messages -->
                    <app-error-html-handler
                      [ctrl]="pickupAddresses.at(i)"
                      [messages]="formValidationMsgs.pickupAddresses">
                    </app-error-html-handler>
                  </div>
                </div>
              </div>
              <div class="center" style="width: 100%; margin-top: 15px;">
                <button class="btn mt-0" (click)="$event.preventDefault(); addPickupAddress()">
                  Aggiungi Indirizzo<i class="ml-10 fas fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </fieldset>
        <br class="clear">
      </div>

      <div class="expert-personal-info">
        <fieldset>
          <legend>CAMPI DI VENDITA:</legend>

          <div class="grid-element-full">
            <label>URL DEL NEGOZIO</label>
            <textarea formControlName="partnerShopUrl" rows="1" placeholder="inserisci qui l'URL del negozio"></textarea>
          </div>

          <div class="col-48 grid-element">
            <label>IMMAGINE</label>
            <input 
              type="file" 
              accept="image/png, image/jpeg, image/jpg, image/gif"
              (change)="onImageSelected($event)"
              *ngIf="!previewUrl"
            >
          </div>
          <div *ngIf="previewUrl" class="product-image-wrapper">
            <img
              [src]="previewUrl"
              class="product-image"
              alt="Product Image"
              height="60"
              width="60"
            />
            <button 
              type="button" 
              class="remove-btn"
              (click)="removeImage()"
            >
              <i class="far fa-times-circle hvr-grow"></i>
            </button>
          </div>
        </fieldset>
        <br class="clear">
      </div>

      <div class="expert-personal-info">
        <fieldset>
          <legend>SICUREZZA:</legend>

          <div class="col-48 grid-element">
            <label class="toggle-container" for="valetIdentity">
              <input type="checkbox" id="valetIdentity" formControlName="checkExpertIndentity">
              <span class="toggle-switch"></span>
              VERIFICA DELL'IDENTITÀ VALET
            </label>
          </div>

          <br class="clear">
          <div class="col-48 grid-element" >
            <label class="toggle-container" for="deliveryCheck">
              <input type="checkbox" id="deliveryCheck" formControlName="deliveryCodeCheck" (change)="handleDeliveryCodeCheck($event)">
              <span class="toggle-switch"></span>
              CODICE DI CONSEGNA RICHIESTO
            </label>
          </div>

          <br class="clear">
          <div class="col-48 grid-element" [ngClass]="{'hidden': !_partnerForm?.get('deliveryCodeCheck').value}">
            <label for="name">TIPO DI CODICE DI CONSEGNA</label>
            <select name="" id="" formControlName="deliveryCodeCheckType">
              <option value="null" selected disabled>Seleziona un tipo qualsiasi</option>
              <option *ngFor="let item of deliveryCodeCheckTypeEnum | enumToArray" value="{{item.name}}">
                {{deliveryCodeCheckTypeStatusAux.ln('it', item.name)}}
              </option>
            </select>
            <app-error-html-handler [ctrl]="_partnerForm.get('deliveryCodeCheckType')" [messages]="formValidationMsgs?.deliveryCodeCheckType"></app-error-html-handler>
          </div>

        </fieldset>
        <br class="clear">
      </div>

      <div class="expert-personal-info" *ngIf="groups.includes('admin') || groups.includes('operation')">
        <fieldset>
          <legend>PARTNER MAGAZZINO:</legend>

          <div class="col-48 grid-element">
            <label class="toggle-container" for="partnerHasWarehouse">
              <input type="checkbox" id="partnerHasWarehouse" formControlName="partnerHasWarehouse">
              <span class="toggle-switch"></span>
              PARTNER MAGAZZINO
            </label>
          </div>

        </fieldset>
        <br class="clear">
      </div>

      <div class="expert-personal-info" *ngIf="groups.includes('admin')">
        <fieldset class="woo-fieldset">
          <legend>WOO COMMERCE API KEY</legend>

          <div class="grid-element-full">
            <label for="wooCommerceApiKey">API KEY</label>

            <div class="api-key-wrapper">
              <input type="text" name="wooCommerceApiKey" formControlName="wooCommerceApiKey" readonly >

              <div class="api-btn-group">
                <button type="button" class="btn hvr-shrink" (click)="generateWooCommerceKey()" >
                  Generate Key
                </button>

                <button type="button" class="btn hvr-shrink secondary-btn" (click)="copyWooKey()" >
                  Copy Key
                </button>
              </div>
            </div>
          </div>

        </fieldset>

        <br class="clear">
      </div>

      <div class="expert-personal-info">
        <fieldset>
          <legend>DOCUMENTAZIONE E NOTE:</legend>
          <div class="grid-element-full">
            <label for="note">Note{{ _partnerForm.get("notes") | required }}</label>
            <textarea formControlName="notes" rows="5" placeholder="Scrivi una nota"></textarea>
          </div>
        </fieldset>
        <br class="clear">
      </div>

      <div class="expert-personal-info" *ngIf="profile">
        <fieldset>
          <legend>Password:</legend>
          <div class="col-48 grid-element" formGroupName="user" *ngIf="profile">
            <label>Password</label>
            <input type="password" name="password1" formControlName="password1">
            <app-error-html-handler [ctrl]="_partnerForm.get('user').get('password1')"
              [messages]="formValidationMsgs.user.password1">
            </app-error-html-handler>
          </div>
          <div class="col-48 grid-element" formGroupName="user" *ngIf="profile">
            <label>Ripeti password</label>
            <input type="password" name="password2" formControlName="password2">
            <app-error-html-handler [ctrl]="_partnerForm.get('user').get('password2')"
              [messages]="formValidationMsgs.user.password2">
            </app-error-html-handler>
          </div>
        </fieldset>
      </div>

      <div class="error-box" style="margin-top:15px" *ngIf="getErrorMessages().length > 0">
        <fieldset>
          <legend>CAMPI OBBLIGATORI:</legend>
          <ul class="error-list">
            <li *ngFor="let error of getErrorMessages()">
              {{ translateErrorMessage(error) }}
            </li>
          </ul>
        </fieldset>
      </div>

      <div class="center mt-20">
        <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()"
          [disabled]="!_partnerForm?.valid || tmpBtnDisabled || isVatChecking()">
          Salva<i class="ml-10 far fa-save"></i>
        </button>
        &nbsp;
        <button [disabled]="tmpBtnDisabled" [routerLink]="['/partner/duplica', partner.id]" type="button" class="btn hvr-shrink center" *ngIf="partner?.id && groups.includes('admin')">
          Duplica<i class="ml-10 far fa-save"></i>
        </button>
      </div>
    </form>
    <br class="clear">
  </div>
</section>
<!-- comment -->